<template>
  <!-- 转岗 -->
  <div class="detail">
    <ax-panel :noTitle="true">
      <van-cell
        title="员工ID"
        :value="data.header.emplid"
      ></van-cell>
      <van-cell
        title="姓名"
        :value="data.header.emplid_description"
      ></van-cell>
    </ax-panel>
    <!-- 调转后信息 -->
    <ax-panel title="调转后信息">
      <van-cell
        title="接收日期"
        :value="data.header.action_dt"
      ></van-cell>
      <!-- 外包隐藏 -->
      <van-cell
        v-if = "data.other.emplClass == 'REG'"
        title="转移HC"
        :value="data.qh_hr_013_hd01.qh_flag == 'Y' ? '是' : '否'"
      ></van-cell>
      <!-- 外包隐藏 -->
      <van-cell
        v-if = "data.other.emplClass == 'REG'"
        title="是否存在优化"
        :value="data.header.qh_optimize_flag == 'Y' ? '是' : '否'"
      ></van-cell>
      <!-- 外包隐藏 -->
      <van-cell
        v-if = "data.other.emplClass == 'REG'"
        title="是否存在违纪"
        :value="data.header.qh_misconduct_flag == 'Y' ? '是' : '否'"
      ></van-cell>
      <van-cell
        title="转入部门"
        :value="data.qh_hr_013_hd01.deptid_description"
      ></van-cell>
      <van-cell
        title="转入序列"
        :value="data.qh_hr_013_hd01.jobcode_description"
      ></van-cell>
      <van-cell
        title="转入直接上级"
        :value="data.qh_hr_013_hd01.supervisor_id_description"
      ></van-cell>
      <!-- 外包显示  -->
      <van-cell
        v-if = "data.other.emplClass == 'OUT'"
        title="转入业务接口人"
        :value="data.qh_hr_013_hd01.qh_outs_receiver_description"
      ></van-cell>
      <van-cell
        title="目标HRBP"
        :value="data.header.qh_hrbp_id_description"
      ></van-cell>
      <van-cell
        title="转入考勤方案"
        :value="data.qh_hr_013_hd01.schedule_id || data.header.schedule_id "
      ></van-cell>
      <van-cell
        title="工作地点"
        :value="data.qh_hr_013_hd01.location_description || data.header.location_description"
      ></van-cell>
      <!-- 外包隐藏  -->
      <van-cell
        v-if = "data.other.emplClass == 'REG'"
        title="社保缴纳地"
        :value="data.qh_hr_013_hd01.gpcn_contrib_area_description || data.header.gpcn_contrib_area_description"
      ></van-cell>
    </ax-panel>
    <!-- 调转原因 -->
    <ax-panel :noTitle="true">
      <van-cell style="border-bottom:none">
        <p class="title">调转原因</p>
      </van-cell>
      <p
        class="desc"
        style="margin-bottom:20px"
      >{{data.header.qh_trans_reason}}</p>
    </ax-panel>
    <!-- 综合评价 -->
    <!-- 外包隐藏 -->
    <ax-panel :noTitle="true" v-if = "data.other.emplClass == 'REG'">
      <van-cell style="border-bottom:none">
        <p class="title">综合评价</p>
      </van-cell>
      <p
        class="desc"
        style="margin-bottom:20px"
      >{{data.header.qh_compeval_reason}}</p>
    </ax-panel>
  </div>
</template>

<script>
import moment from 'moment';
export default {
  props: ['data'],
  data() {
    return {};
  },
  methods: {}
};
</script>
<style lang="scss" scoped>
.van-cell .van-cell__value {
  text-align: right;
  padding-right: 0.4rem;
}
.van-cell {
  border-bottom: 1px solid $border-color;
}
.base {
  border-bottom: none;
}
.van-cell__right-icon {
  // margin-left: -2.8rem;
  // float: right;
  position: absolute;
  right: 0.1rem;
}
.van-cell .van-cell__title {
  width: 4rem;
  // color:#000
}
.w100 .van-cell__title {
  width: 8rem;
}
.van-collapse-item__wrapper .van-collapse-item__content {
  color: rgba(0, 0, 0, 0.9);
}
.title {
  color: rgba(0, 0, 0, 0.3);
  // color: #000;
  font-size: 0.4rem;
  text-align: left;
  padding-left: 0.42667rem;
}
.desc {
  color: #ccc;
  padding-left: 25px;
  font-size: 0.4rem;
  text-align: left;
}
</style>